import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Store } from '@ngrx/store';
import { selectGlobalLoading } from '../../../store/ui/ui.selectors';

/** Full-screen loading overlay, shown while any tracked HTTP request is in flight. */
@Component({
  selector: 'csd-loader',
  standalone: true,
  imports: [AsyncPipe, MatProgressSpinnerModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent {
  private readonly store = inject(Store);

  readonly loading$ = this.store.select(selectGlobalLoading);
}
